import {defineAsyncComponent, defineComponent, h, onMounted, onBeforeUnmount, ref} from 'vue';

export function deferUntilVisible(loader) {
    const component = defineAsyncComponent(loader);
    return defineComponent({
        inheritAttrs: false,
        setup(props, {attrs, slots}) {
            const root = ref(null);
            const visible = ref(false);
            let observer;
            onMounted(() => {
                if (!('IntersectionObserver' in window)) {
                    visible.value = true;
                    return;
                }
                observer = new IntersectionObserver(entries => {
                    if (entries.some(entry => entry.isIntersecting)) {
                        visible.value = true;
                        observer.disconnect();
                    }
                }, {rootMargin: '300px'});
                observer.observe(root.value);
            });
            onBeforeUnmount(() => observer?.disconnect());
            return () => h('div', {ref: root, class: 'deferred-section'}, visible.value ? [h(component, attrs, slots)] : []);
        },
    });
}
